import React from 'react';
import {DateField, Tab, TextField, useTranslate} from 'react-admin';
import ChangeHistoryIcon from '@mui/icons-material/ChangeHistory';
import {D4UrlField} from "../../d4tools";

function D4TabBase(props, controllerProps) {
    const translate = useTranslate();

    return (
        <Tab label={translate('resources.base.name')} path="base" icon={<ChangeHistoryIcon/>}>
            <TextField label={translate('resources.base.fields.aspect')} source="base:aspect"/>
            <TextField label={translate('resources.base.fields.name')} source="base:name"/>
            {controllerProps.record && "base:description" in controllerProps.record &&
                <TextField label={translate('resources.base.fields.description')} source="base:description"/>
            }
            {controllerProps.record && "base:created" in controllerProps.record &&
                <DateField label={translate('resources.base.fields.created')} source="base:created" showTime/>
            }
            {controllerProps.record && "base:modified" in controllerProps.record &&
                <DateField label={translate('resources.base.fields.modified')} source="base:modified" showTime/>
            }
            {controllerProps.record && "base:origin" in controllerProps.record &&
                <TextField label={translate('resources.base.fields.origin')} source="base:origin"/>
            }
            <TextField label={translate('resources.base.fields.scope.one')} source="base:scope"/>
            <TextField label={translate('resources.base.fields.type.one')} source="base:type"/>
            <D4UrlField label="" source="id"/>
        </Tab>
    );
}

export default D4TabBase;